import { render } from "./submission-responses-panel.vue?vue&type=template&id=2924a8de&scoped=true&ts=true"
import script from "./submission-responses-panel.vue?vue&type=script&lang=ts"
export * from "./submission-responses-panel.vue?vue&type=script&lang=ts"

import "./submission-responses-panel.vue?vue&type=style&index=0&id=2924a8de&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2924a8de"]])

export default __exports__